import actionTypes from './action-types';
import getterTypes from './getter-types';
import mutationTypes from './mutation-types';
import cartGetterTypes from '../cart/getter-types';

export default {
  [actionTypes.SHOW] ({ commit }, { offerMeal, soldOut }) {
    commit(mutationTypes.SET_OFFER_MEAL, offerMeal);
    commit(mutationTypes.SET_SOLD_OUT, soldOut);
    commit(mutationTypes.SET_UPDATED_OFFER_MEAL_ID, null);
    commit(mutationTypes.SET_VISIBLE, true);
  },
  [actionTypes.UPDATE] ({ commit }, { offerMeal, soldOut }) {
    commit(mutationTypes.SET_OFFER_MEAL, offerMeal);
    commit(mutationTypes.SET_SOLD_OUT, soldOut);
    commit(mutationTypes.SET_PRICE_FORMATTED, null);
    commit(mutationTypes.SET_UPDATED_OFFER_MEAL_ID, offerMeal.id);
  },
  [actionTypes.HIDE] ({ commit }) {
    commit(mutationTypes.SET_VISIBLE, false);
    commit(mutationTypes.SET_OFFER_MEAL, null);
    commit(mutationTypes.SET_SOLD_OUT, null);
    commit(mutationTypes.SET_PRICE_FORMATTED, null);
    commit(mutationTypes.SET_UPDATED_OFFER_MEAL_ID, null);
  },
  [actionTypes.CONFIGURE] ({ commit, getters, rootGetters }, {ingredients, amount}) {
    let offerMeal = getters[getterTypes.GET_OFFER_MEAL];
    if (!offerMeal) return;

    commit(mutationTypes.SET_VALID, false);
    commit(mutationTypes.SET_ERRORS, []);

    return window.axios.post(rootGetters['cart/' + cartGetterTypes.GET_UPDATE_CART_URL] + '/offer-meal/configure', {
      offer_meal_id: offerMeal.id,
      ingredients: ingredients,
      amount: amount,
    }).then(response => {
      if (response.data.valid) {
        commit(mutationTypes.SET_PRICE_FORMATTED, response.data.price_formatted);
        commit(mutationTypes.SET_PACKAGING_PRICE_FORMATTED, response.data.packaging_price_formatted);
        commit(mutationTypes.SET_VALID, true);
      } else {
        commit(mutationTypes.SET_PRICE_FORMATTED, response.data.price_formatted);
        commit(mutationTypes.SET_PACKAGING_PRICE_FORMATTED, response.data.packaging_price_formatted);
        commit(mutationTypes.SET_ERRORS, response.data.errors);
      }
    });
  },
}
